var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandBuilderStyleWhite = function SvgBrandBuilderStyleWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.97 6.743a6.73 6.73 0 0 1-2.503 5.245L2.475 1.77a1 1 0 0 1-.19-.141A.952.952 0 0 1 2.951 0H16.23a6.737 6.737 0 0 1 6.74 6.743M22.97 17.233a6.74 6.74 0 0 1-6.74 6.744H2.95a.951.951 0 0 1-.476-1.77l7.081-4.022 10.91-6.196a6.74 6.74 0 0 1 2.503 5.244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.467 11.988-10.91 6.197-7.082 4.021a1 1 0 0 0-.187.138c2.7-2.77 4.21-6.487 4.206-10.356A14.81 14.81 0 0 0 2.29 1.63a1 1 0 0 0 .19.141z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandBuilderStyleWhite);
export { ForwardRef as ReactComponent };